// extracted by mini-css-extract-plugin
export default {"modalProfile":"Modal_modalProfile__7Pi7y","modalDirectory":"Modal_modalDirectory__sb3i1"};